import { FormFaq } from './programForm.types';

export const FAQ_SUGGESTIONS: ReadonlyArray<FormFaq> = [
  {
    question: 'What are the goals of this program?',
    answer: `* Increase overall lean muscle mass
* Get lean and burn fat
* Build core strength
* Improve posture
* Improve mental clarity and focus`,
  },
  {
    question: 'What do I need to participate?',
    answer: `* You need a gym membership that has standard workout equipment
* A positive attitude and dedication to the program`,
  },
  {
    question: 'Who are these workouts for (skill-level)?',
    answer: `* The workouts are designed for all levels
* Beginners: go slow, use less weight, use longer rest periods, and focus on form
* Advanced: increase weight, reps and reduce rest time as you progress`,
  },
  {
    question: `What’s the schedule?`,
    answer: `* Weight training 3-4 times per week
* 2 days of active rest: When you rest from lifting, you should still remain active. Do HIIT cardio/ab workouts, play sports, go for a hike or a long walk
* 1 full rest day`,
  },
  {
    question: 'How will I get the best results?',
    answer: `* Get proper sleep (7-9 hours a night is a must)
* Dedicated nutrition regimen that consists only of wholesome, natural ingredients (get my nutrition guide in “Insights” section of the app)
* Drink at least eight 8 oz glasses of water daily
* Make sure to use active and full rest days to allow muscles to recover
* Ice cold showers in the morning and after workouts are highly recommended`,
  },
  {
    question: 'Are there any modifications for the exercises?',
    answer: `* Yes! I’ve included modifications in the descriptions for each exercise. If you need further assistance modifying any workouts, send me a message in the app and I’ll be happy to help!`,
  },
  {
    question: 'How can I ask you questions?',
    answer: `Message me in the app for any questions you have. I do my best to review all comments and make any recommended changes.

I want to see your progress!

I would also love to see your progress pictures and videos. Tag me on Instagram and use the hashtag [INSERT HASHTAG HERE] or feel free to shoot me a DM on IG. I would love to showcase your progress to our community.`,
  },
];
